import Vue from 'vue';
import objectAssignDeep from 'object-assign-deep';
import { StripeCheckout } from '@vue-stripe/vue-stripe';
import axios from 'axios'
import VueAxios from 'vue-axios'
import VeeValidate, { Validator } from 'vee-validate';
import fr from './locale/_fr.js';
let controller = new AbortController();

Vue.use(VueAxios, axios)
Vue.use(VeeValidate);
Validator.localize('fr', fr);

Vue.filter("formatNumber", function (value) {
    var formatter = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
    return formatter.format(value);
});

new Vue({
    el: "#registration-process",
    delimiters: ['${', '}'],
    components: {
        StripeCheckout: StripeCheckout,
    },
    computed:{
        market_other(){
            let o = this.form.markets.filter(function (elm) {
                return elm.label.toLowerCase() == "autre" });
            return o.length === 1;
        },
        discipline_other(){
            let o = this.form.discipline.filter(function (elm) {
                return elm.label.toLowerCase() == "autre" });
            return o.length === 1;
        },
        tech_other(){
            let o = this.form.tech.filter(function (elm) {
                return elm.label.toLowerCase() == "autre" });
            return o.length === 1;
        },
        is_asd(){
            let o = this.form.markets.filter(function (elm) {
                return elm.label == "Aéronautique, spatial et défense" });
            return o.length === 1;
        },
        is_health(){
            let o = this.form.markets.filter(function (elm) {
                return elm.label == "Technologies de santé" });
            return o.length === 1;
        },
        cart(){
            let cart = {};
            if(this.form.ca && this.price) {
                cart.price = this.price;
                cart.subtotal = this.price;

                if (this.coupon) {
                    if (this.coupon.discount_mode === "1") {
                        cart.discount = this.coupon.amount;
                    } else {
                        cart.discount = cart.subtotal * (this.coupon.percent / 100);
                    }
                    cart.subtotal -= cart.discount;
                }
                cart.vat = cart.subtotal * 0.2;
                cart.total = cart.subtotal * 1.2;
            }
            return cart;
        }
    },
    data: function () {
        let form = {
            name: "",
            siret: "",
            naf: "",
            ca: "",
            phone: "",
            website: "",
            type_structure: "",
            langs: [],
            markets: [],
            markets_precision: "",
            discipline: [],
            discipline_precision: "",
            tech: [],
            tech_precision: "",
            activity: '',
            logo: {},
            white_logo: {},
            pics: [],
            address: {
                line1 : "",
                postal_code : "",
                city : "",
                country : "",
            },
            social_networks:{
                facebook: null,
                linkedin: null,
                twitter: null
            },
            custom_book_contact: "0",
            contacts:{
                manager : { civility: "", firstname: null, lastname: null, email: null, phone: null},
                book : { civility: "", firstname: null, lastname: null, email: null, phone: null},
                administrative : { civility: "", firstname: null, lastname: null, email: null, phone: null},
                asd : { civility: "", firstname: null, lastname: null, email: null, phone: null},
                health : { civility: "", firstname: null, lastname: null, email: null, phone: null}
            },
            register_child: false,
            payment_method: null,
            discount: null,
        };
        return {
            currentStep: 1,
            currentTab: "markets",
            form: form,
            stripe: {
                key: "",
                sessionId: "",
            },
            coupon: null,
            countries: window.countries,
            langs: window.langs,
            price: null,
            success: false,
            isProcessing: false
        }
    },
    async mounted() {
        if(window.structure_id){
            this.getModel(window.structure_id);
        }

        var url = new URL(window.location.href);
        if(url.searchParams.get("type")){
            var type = JSON.parse(url.searchParams.get("type"));
            this.form.type_structure = type;
        }

        if(url.searchParams.get("ca")){
            var ca = url.searchParams.get("ca");
            this.form.ca = ca;
        }

        await this.getPricing();
    },
    methods: {
        async getModel(id) {
            const { data } = await this.$http.get(
                '/mon-compte/modifier-ma-structure/'+id+'/model',
            );

            let contacts = objectAssignDeep({}, this.form.contacts, data.contacts)

            let formData = objectAssignDeep({}, this.form, data);
            formData.contacts = contacts;
            this.form = formData;
            await this.getPricing();
            return data;
        },
        async getSession() {
            let formData = Object.assign({}, this.form, {directory: {asd: this.is_asd, health: this.is_health}}, {cart: this.cart});
            if(window.rejoin){
                formData = Object.assign({}, formData, {rejoin: window.structure_id});
            }
            const { data } = await this.$http.post(
                '/gateway/checkout',
                formData
            );
            return data;
        },
        async validateCoupon() {
            const { data } = await this.$http.post(
                '/gateway/validate-coupon',
                {code: this.form.discount}
            );

            if (data.status == "success") {
                this.coupon = data.coupon;
                this.form.discount = this.coupon.code;
            } else {
                this.coupon = null;
                this.form.discount = "";
            }
        },
        async checkSIRET() {
            const { data } = await this.$http.post(
                '/gateway/check-siret',
                {siret: this.form.siret}
            );
            if (data.status === "already-exist") {
                alert("Une structure avec ce N° de SIRET existe déja.")
            }
        },
        async getPricing() {
            if (controller) controller.abort();
            controller = new AbortController();
            const signal = controller.signal;
            if(this.form.type_structure.id && this.form.ca) {
                try {
                    const {data} = await this.$http.post(
                        '/gateway/get-price',
                        {structure: this.form.type_structure.id, ca: this.form.ca},
                        {signal: signal}
                    );
                    if(data.status == "success"){
                        this.price = data.price.price;
                    }
                }catch (e) {
                    this.price = null;
                }
            }
        },
        checkout: function () {
            let _this = this;
            if(!this.isProcessing) {
                this.isProcessing = true;
                this.getSession().then((data) => {
                    if (_this.form.payment_method == 'stripe') {
                        _this.stripe.key = data.key;
                        _this.stripe.sessionId = data.session;

                        setTimeout(() => {
                            _this.$refs.checkoutRef?.redirectToCheckout();
                        }, 250)

                    } else if (data.redirectTo) {
                        window.location.href = data.redirectTo;
                    }
                    _this.isProcessing = false;
                }).catch(() => {
                    _this.isProcessing = false;
                    alert("Une erreur s'est produite, veuillez réessayer ultérieurement");
                })
            }
        },
        async saveEdit () {
            let _this = this;
            if(!this.isProcessing) {
                this.isProcessing = true;
                let formData = Object.assign({}, this.form, {directory: {asd: this.is_asd, health: this.is_health}});
                this.$http.post(
                    '/mon-compte/modifier-ma-structure/' + window.structure_id,
                    formData
                ).then((res) => {
                    if (res.data.status == "success") {
                        this.success = true;
                    }
                    this.isProcessing = false;
                }).catch(() => {
                    this.isProcessing = false;
                    alert("Une erreur s'est produite, veuillez réessayer ultérieurement");
                });
            }
        },
        prevStep: function () {
            if (this.currentStep === 3) {
                switch (this.currentTab) {
                    case "markets":
                        this.currentTab = "discipline"
                        return;
                    case "tech":
                        this.currentTab = "markets"
                        return;
                }
            }
            this.currentStep = Math.max((this.currentStep - 1), 1);
        },
        nextStep: function () {
            this.$validator.validateAll().then((result) => {
                document.querySelector('.main .content').scrollTop = 0;
                if(!this.form.logo.data){
                    this.$validator.errors.add({
                        field: 'logo',
                        msg: 'Vous devez ajouter votre logo.',
                    })
                    result = false;
                }
                if(this.price == null){
                    this.$validator.errors.add({
                        field: 'ca',
                        msg: 'Vous chiffre d\'affaire ne permet pas d\'adhérer en ligne. Veuillez nous contacter.',
                    })
                    result = false;
                }
                if (result) {
                    if (this.currentStep === 3) {
                        switch (this.currentTab) {
                            case "markets":
                                this.currentTab = "tech"
                                return;
                            case "tech":
                                this.currentTab = "discipline"
                                return;
                        }
                    }
                    this.currentStep += 1;
                    return;
                }

            });
        },
        onLogoChange: function (event) {
            var _this = this;
            var readers = [];
            for (var i = 0; i < event.target.files.length; i++) {
                var file = event.target.files[i];
                readers[i] = new FileReader();
                readers[i].onload = (event) => {
                    _this.form.logo = {
                        name: file.name,
                        fileSize: file.size,
                        type: file.type,
                        data: event.target.result
                    };
                }
                if (file.name) {
                    readers[i].readAsDataURL(file);
                }
            }

            if(!event.target.files.length){
                this.$validator.errors.add({
                    field: 'logo',
                    msg: 'Vous devez ajouter votre logo.',
                })
            }
        },
        removeLogo: function (i) {
            this.form.logo = {};
            this.$refs.logos.value = '';

            this.$validator.errors.add({
                field: 'logo',
                msg: 'Vous devez ajouter votre logo.',
            })
        },
        dropLogo: function (event) {
            event.preventDefault();
            this.onLogoChange(event);
            // Clean up
            event.currentTarget.classList.add('drop');
            event.currentTarget.classList.remove('drag-leave');
            event.currentTarget.classList.remove('drag-over');
        },
        onWhiteLogoChange: function (event) {
            var _this = this;
            var readers = [];
            for (var i = 0; i < event.target.files.length; i++) {
                var file = event.target.files[i];
                readers[i] = new FileReader();
                readers[i].onload = (event) => {
                    _this.form.white_logo =  {
                        name: file.name,
                        fileSize: file.size,
                        type: file.type,
                        data: event.target.result
                    };
                }
                if (file.name) {
                    readers[i].readAsDataURL(file);
                }
            }
        },
        removeWhiteLogo: function (i) {
            this.form.white_logo = {};
            this.$refs.white_logos.value = ''
        },
        dropWhiteLogo: function (event) {
            event.preventDefault();
            this.onWhiteLogoChange(event);
            // Clean up
            event.currentTarget.classList.add('drop');
            event.currentTarget.classList.remove('drag-leave');
            event.currentTarget.classList.remove('drag-over');
        },
        onPicsChange: function (event) {
            var _this = this;
            if (_this.form.pics.length >= 2 ) {
                alert("Vous avez atteint le nombre maximum d'images")
            }
            var readers = [];
            for (var i = 0; i < event.target.files.length; i++) {
                var file = event.target.files[i];
                readers[i] = new FileReader();
                readers[i].onload = (event) => {
                    _this.form.pics.push(
                        {
                            name: file.name,
                            fileSize: file.size,
                            type: file.type,
                            data: event.target.result
                        }
                    );
                }
                if (file.name) {
                    readers[i].readAsDataURL(file);
                }
            }
        },
        removePics: function (i) {
            this.form.pics.splice(i, 1);
        },
        dropPics: function (event) {
            event.preventDefault();
            this.onPicsChange(event);
            // Clean up
            event.currentTarget.classList.add('drop');
            event.currentTarget.classList.remove('drag-leave');
            event.currentTarget.classList.remove('drag-over');
        },
        dragover: function (event) {
            event.preventDefault();
            // Add some visual fluff to show the user can drop its files
            event.currentTarget.classList.add('drag-over');
            event.currentTarget.classList.remove('drop');
            event.currentTarget.classList.remove('drag-leave');
        },
        dragleave: function (event) {
            // Clean up
            event.currentTarget.classList.add('drag-leave');
            event.currentTarget.classList.remove('drop');
            event.currentTarget.classList.remove('drag-over');
        }
    }
});
